import DocumentTitle from '@perpay-web/components/base/DocumentTitle/DocumentTitle';

export function withPerpayTitle(title) {
    return (Component) => {
        const TitleWrapper = (props) => (
            <>
                <DocumentTitle title={title} />
                <Component {...props} />
            </>
        );

        TitleWrapper.displayName = 'TitleWrapper';

        return TitleWrapper;
    };
}
